import { render } from "./Vehicles.vue?vue&type=template&id=b98dbad6&scoped=true"
import script from "./Vehicles.vue?vue&type=script&lang=js"
export * from "./Vehicles.vue?vue&type=script&lang=js"

import "./Vehicles.vue?vue&type=style&index=0&id=b98dbad6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b98dbad6"]])

export default __exports__